import React from 'react';

import ProjectPhaseComponent from 'components/ProjectPhase';

const ProjectPhase: React.FC = () => <ProjectPhaseComponent />

export default ProjectPhase;